import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import ShopRiderCodes from 'ApplicationEntry/components/WorkFlow/ProductsRiders/Group/ShopRiderCodes';
import PackageSelect from 'ApplicationEntry/components/WorkFlow/ProductsRiders/PackageSelect';
import {CaseDetails, matchCaseDetailsByType} from 'ApplicationEntry/models/CaseDetails';
import {isValidPolicyNumberPaperElectronic} from 'ApplicationEntry/models/EnteredPolicyNumber';
import {InvalidGroupShop, ValidGroupShop} from 'ApplicationEntry/models/ProductsRiders/Shop/GroupShop';
import {getAllRiderCodes, groupPlanCodes, isShop1} from 'ApplicationEntry/models/ProductsRiders/Shop/Shop';
import States from 'ApplicationEntry/models/States';
import {isNonEmptyString} from 'Core/models/EmptyString';
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import * as ErrorMessages from '../../ErrorMessages';
import './Shop.sass';
import * as BAActions from 'ApplicationEntry/ducks/billingAgent';
import * as SActions from 'ApplicationEntry/ducks/ProductsRiders/shop';
import useBuildPremiumParameterAutoFill from './useBuildPremiumParameterAutoFill';
import {BillingAgent} from 'ApplicationEntry/models/BillingAgent';
import {ApplicantDemographics} from 'ApplicationEntry/models/ApplicantDemographics';
import {ValidGroupCaseDetails} from 'ApplicationEntry/models/GroupCaseDetails';
import {NonEmptyString, StringUnion} from 'Core/models/EmptyString';
import FixedCodeRiderInformation from '../FixedCodeRiderInformation';
import {Plan} from 'ApplicationEntry/models/ProductsRiders/PlanModel';
import {getSitusStatefromCaseNumber} from 'ApplicationEntry/ducks/caseDetails';

type ShopProps = {
  shop: InvalidGroupShop | ValidGroupShop;
  caseDetails: CaseDetails;
  billingAgent: BillingAgent;
  applicantDemographics: ApplicantDemographics;
};

const Shop = ({caseDetails, shop, billingAgent, applicantDemographics}: ShopProps) => {
  const dispatch = useDispatch();
  const {
    planType,
    cwa,
    section125,
    calculatedPremium,
    riderAmounts,
    policyNumber,
    replacement,
    situs,
    riderCoverage,
    riderPremium,
    packageList,
    plan,
    riderInformation,
    packageOption,
    jstamp,
  } = shop;
  const {billingMode} = billingAgent;
  const {dateOfBirth} = applicantDemographics;
  let {billingCode, situsState, userAuthorizedJStamp} = caseDetails as ValidGroupCaseDetails;
  const [policyNumberBlurred, setPolicyNumberBlurred] = useState(false);
  const [planTypeLabel, setPlanTypeLabel] = useState<HTMLLabelElement | null>();
  const [situsLabel, setSitusLabel] = useState<HTMLLabelElement | null>();
  const showPolicyNumberError = policyNumberBlurred && !isValidPolicyNumberPaperElectronic(policyNumber) && replacement;

  const handleAutoFillPremiumGrpProducts = useBuildPremiumParameterAutoFill();

  // useEffect(() => {
  //   if (isNonEmptyString(plan)) {
  //     const caseNum = matchCaseDetailsByType({
  //       Group: groupApp =>
  //         groupApp.caseNumber.key === 'Loaded'
  //           ? groupApp.caseNumber.Data
  //           : groupApp.caseNumber.key === 'UserAssignedCaseNumber'
  //           ? groupApp.caseNumber.value
  //           : '',
  //       _: () => '',
  //     })(caseDetails);
  //     dispatch(SActions.getPackages(plan.value, caseNum));
  //   }
  // }, [caseDetails, dispatch, plan]);

  return (
    <div className="product-riders-section__policy-type" id="shop-section">
      <form noValidate autoComplete="off" className="product-riders-section__policy-type__form">
        <div className="product-riders-section__policy-type__form__row">
          <Grid container spacing={4}>
            <Grid item xs={12} md={3}>
              <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
                <InputLabel ref={setPlanTypeLabel} id="shop-plantype-label">
                  Plan
                </InputLabel>
                <Select
                  labelId="shop-label-plantype"
                  labelWidth={planTypeLabel?.clientWidth}
                  id="shop-plantype"
                  value={plan.key === 'Empty' ? '' : plan.value}
                  onChange={e => {
                    dispatch(SActions.changePlan(e.target.value as string));

                    const caseNumber = matchCaseDetailsByType({
                      Group: groupApp =>
                        groupApp.caseNumber.key === 'Loaded'
                          ? groupApp.caseNumber.Data
                          : groupApp.caseNumber.key === 'UserAssignedCaseNumber'
                          ? groupApp.caseNumber.value
                          : '',
                      _: () => '',
                    })(caseDetails);
                    // dispatch(SActions.changeRiderCodeList(e.target.value as string));
                    if (e.target.value === 'GVSP2') {
                      const PlanObj: Plan = {};
                      PlanObj.life70Name = 'GVS2';
                      PlanObj.name = 'GVSP2';
                      dispatch(SActions.getOccClass(caseNumber, PlanObj));
                    }

                    dispatch(SActions.getPackages(e.target.value as string, caseNumber));
                  }}
                  displayEmpty
                >
                  {groupPlanCodes.map(p => (
                    <MenuItem value={p} key={p}>
                      {p}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {plan.key === 'NonEmpty' ? (
              <>
                <PackageSelect
                  packageName={packageOption}
                  packageList={packageList}
                  changePackageAction={SActions.changePackage}
                  handlePackageItems={(packageItem: object) => {
                    if (billingMode.value !== '') {
                      handleAutoFillPremiumGrpProducts(
                        plan,
                        packageItem,
                        billingMode,
                        planType,
                        dateOfBirth,
                        undefined
                      );
                    } else if (billingCode.value !== '') {
                      handleAutoFillPremiumGrpProducts(
                        plan,
                        packageItem,
                        billingCode,
                        planType,
                        dateOfBirth,
                        undefined
                      );
                    }
                    dispatch(SActions.changePackageItem(packageItem));
                  }}
                />

                <Grid item xs={12} md={3}>
                  <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
                    <InputLabel ref={setPlanTypeLabel} id="shop-plantype-label">
                      Plan Type
                    </InputLabel>
                    <Select
                      labelId="shop-label-plantype"
                      labelWidth={planTypeLabel?.clientWidth}
                      id="shop-plantype"
                      value={planType.key === 'Empty' ? '' : planType.value}
                      onChange={e => {
                        dispatch(SActions.changePlanType(e.target.value as string));
                        if (billingMode.value !== '') {
                          handleAutoFillPremiumGrpProducts(
                            plan,
                            null,
                            billingMode,
                            NonEmptyString.create(e.target.value as string) as StringUnion,
                            dateOfBirth,
                            undefined,
                            undefined,
                            packageList,
                            packageOption
                          );
                        } else if (billingCode.value !== '') {
                          handleAutoFillPremiumGrpProducts(
                            plan,
                            null,
                            billingCode,
                            NonEmptyString.create(e.target.value as string) as StringUnion,
                            dateOfBirth,
                            undefined,
                            undefined,
                            packageList,
                            packageOption
                          );
                        }
                      }}
                      displayEmpty
                    >
                      <MenuItem value="IND">Individual</MenuItem>
                      <MenuItem value="FAMILY">Family</MenuItem>
                      <MenuItem value="INDSPS">Ind+Sp</MenuItem>
                      <MenuItem value="INDCH">Ind+Ch</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
                    <InputLabel ref={setSitusLabel} id="shop-situs-label">
                      Situs State
                    </InputLabel>
                    <Select
                      labelId="shop-label-situs"
                      labelWidth={situsLabel?.clientWidth}
                      id="shop-situs"
                      value={situsState.value || situs.value}
                      onChange={e => {
                        dispatch(SActions.changeSitus(e.target.value as string));
                        dispatch(getSitusStatefromCaseNumber(''));
                      }}
                      displayEmpty
                    >
                      {States.map(stateCode => (
                        <MenuItem key={stateCode} value={stateCode}>
                          {stateCode}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    id="shop-premium"
                    label="Premium"
                    variant="outlined"
                    placeholder="Premium"
                    margin="normal"
                    fullWidth
                    className="shop-section__form-text-field"
                    value={calculatedPremium.key === 'Empty' ? '' : calculatedPremium.value}
                    onChange={event => {
                      dispatch(SActions.changePremium(event.target.value as string));
                      dispatch(SActions.changeCalculatedPremium(event.target.value as string));
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    id="shop-cwa"
                    label="CWA"
                    variant="outlined"
                    placeholder="CWA"
                    margin="normal"
                    fullWidth
                    className="product-riders-section__policy-type__form__row--field"
                    value={cwa.key === 'Empty' ? '' : cwa.value}
                    onChange={e => dispatch(SActions.changeCWA(e.target.value as string))}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="secondary"
                        checked={replacement}
                        onChange={() => dispatch(SActions.changeReplacement(!replacement))}
                        name="checkedB"
                      />
                    }
                    label={<Typography>Replacement</Typography>}
                    className="shop-section__form-text-field"
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    id="iwl-polNum"
                    label="Policy Number"
                    variant="outlined"
                    placeholder="Enter Policy Number"
                    margin="normal"
                    fullWidth
                    error={showPolicyNumberError}
                    helperText={showPolicyNumberError ? ErrorMessages.INVALID_POLICY_NUMBER : ''}
                    className="iwl-section__form-text-field"
                    value={policyNumber.key !== 'ValidPolicyNumber' || !replacement ? '' : policyNumber.value.value}
                    onBlur={() => setPolicyNumberBlurred(true)}
                    onChange={e => dispatch(SActions.changePolicyNumber(e.target.value as string))}
                    disabled={!replacement}
                    inputProps={{
                      maxLength: 10,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="checkedB"
                        color="secondary"
                        id="shop-section125"
                        checked={section125}
                        onChange={() => dispatch(SActions.changeSection125(!section125))}
                      />
                    }
                    label={<Typography>Section 125</Typography>}
                    className="shop-section__form-text-field"
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="checkedB"
                        color="secondary"
                        id="shop-section125"
                        checked={jstamp}
                        disabled={!userAuthorizedJStamp}
                        onChange={() => dispatch(SActions.changeJStamp(!jstamp))}
                      />
                    }
                    label={<Typography>J-Stamp</Typography>}
                    className="shop-section__form-text-field"
                  />
                </Grid>

                {isShop1(plan.value) ? <></> : null}
              </>
            ) : null}
          </Grid>
          {plan.key === 'NonEmpty' ? (
            <FixedCodeRiderInformation
              riderInformation={riderInformation}
              changeRiderInformationAction={SActions.changeRiderInformation}
              isDisabled={true}
              identifier={'group-shop'}
            />
          ) : null}
        </div>
      </form>
    </div>
  );
};

export default Shop;
